import * as tslib_1 from "tslib";
import { BasicModel } from './basic.model';
import { City } from './city.model';
var Address = /** @class */ (function (_super) {
    tslib_1.__extends(Address, _super);
    function Address() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Address;
}(BasicModel));
export { Address };
var Location = /** @class */ (function (_super) {
    tslib_1.__extends(Location, _super);
    function Location(data) {
        return _super.call(this, tslib_1.__assign({ address: new Address(), city: new City() }, data)) || this;
    }
    return Location;
}(BasicModel));
export { Location };
